import React from "react";
function ModifyInfo()
{
    return(
        <>
        <h2> Modify Information</h2>
        </>
    )
}
export default ModifyInfo;